import './wdyr' // <--- first import

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './i18n'
import './index.css'
import App from './Core/App'
import Authentication from './Auth/Components/Authentication'
import store from './Core/Redux/Store'
import reportWebVitals from './reportWebVitals'
import logger from './Common/Utils/Logger'
import { FREC, PROMETHEUS } from './Common/Utils/Portal'

// MSAL imports
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './Auth/Services'
import PortalProvider from './Core/Providers/PortalProvider'

logger.info('Intializing Prometheus UI Application')

const avoidAuthentication = /^\/500/.test(window.location.pathname) || /^\/maintenance/.test(window.location.pathname)
const isFrec = /\/frec\//.test(window.location.pathname)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <PortalProvider dftPortal={isFrec ? FREC : PROMETHEUS}>
          <App noStartup={avoidAuthentication} />
          {!avoidAuthentication && (
            <Authentication />
          )}
        </PortalProvider>
      </MsalProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
